export const MEDIA_FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'artwork', label: 'Artwork' },
  { key: 'characters', label: 'Characters' },
  { key: 'promo', label: 'Promo' },
  { key: 'community', label: 'Community' },
  { key: 'videos', label: 'Videos' },
];

export function formatMediaDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function mediaDetailPath(item, category = 'all') {
  const base = `/media/${item.id}`;
  return category && category !== 'all' ? `${base}?category=${encodeURIComponent(category)}` : base;
}

/** Selected item first, then remaining published items newest-first. */
export function buildFeedOrder(items, selectedId) {
  if (!items.length) return [];
  const id = String(selectedId);
  const selected = items.find((i) => String(i.id) === id);
  if (!selected) return [...items];
  const rest = items.filter((i) => String(i.id) !== id);
  return [selected, ...rest];
}
